<template>
  <div class="box">
    <header class="header">
      <div style="width: 1000px;height: 560px;margin-left: 40px;">
        <div v-if="this.img_data.length === 0">
          <el-image style="width: 100%;height: 100%;" :src="banner" />
        </div>
        <el-carousel v-if="this.img_data.length !== 0" class="new-item1 new-item2" :autoplay="true" arrow="never" ref="cardShow" :initial-index="0" height="560px" :interval="15000">
          <el-carousel-item class="carousel flex" v-for="(item, index) in img_data" :key="index">
            <div>
              <el-image style="width: 100%;height: 100%;" :src="item.bdbi_path" @error="srcerr1(item,$event)" />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </header>
    <nav>
      <!-- 中间功能模块 二维码、抽福袋、数字货币 -->
      <div class="content_top">
        <!-- 微信扫码领券模块 -->
        <div class="content_nav_left">
          <el-image style="width: 100%;height: 100%;position: absolute;left: -6px;" :src="box_i" />
          <!-- 操作提示 -->
          <div style="width: 80px;margin-top: 30px;display: flex;margin-left: 290px;">
            <el-image :src='s' style="width: 30px;height: 30px; margin-right: 5px;margin-bottom: 6px;" />
            <el-image :src='gl' style="width: 30px;height: 40px; margin-right: 25px;" @click='wxsm_show=true' />
          </div>
          <!-- 二维码 -->
          <el-image style="width: 129px;height: 131px;position: absolute;top: 114px;left: 61px;border-radius: 5px" :src="bdbi_path" />
          <!-- 活动列表----只展示前三个 -->
          <div style="width: 265px;height: 146px;position: absolute;top: 109px;left: 275px;">
            <div style="width: 100%;height: 50px;font-size: 22px;text-align: center;line-height: 40px;color: #ff4940;" v-for="(item1 ,index1) in business_data[0]" :key="index1">{{item1.bai_m_caption}}</div>
          </div>
        </div>
        <!-- 幸运福袋模块 -->
        <div style="width: 180px;height: 310px;" @click.stop='activity_list'>
          <el-image style="width: 100%;height: 100%;" :src="prizeBag" />
        </div>
        <!-- 数字人民币模块 -->
        <div style="width: 180px;height: 310px;">
          <el-image style="width: 100%;height: 100%;" :src="digitalCurrency" />
        </div>
      </div>
      <!-- 商品数据列表 轮播图 -->
      <div class="content">
        <div style="width: 100%;height: 30px;"></div>
        <!-- 商品列表标题 -->
        <div class="content_nav">
          <div>移动支付便民</div>
          <el-image style="width: 110px;" :src="size2" />
          <div style="margin-right: 20px;">工程</div>
          <el-image :src='s' class="hand" />
          <el-image :src='gl' class="book" @click='ydzf_show=true' />
          <div class="content_nav_btn">
            <div class="btn1" @click="btnClick(1,'left')">设备出货</div>
            <div class="btn1" @click="btnClick(2,'right')">到店体验</div>
          </div>
        </div>
        <div style="background-color: rgb(254, 110, 72); width: 938px;height: 6px;margin: 0 auto;"></div>
        <div class="btn_border1" v-show="btn_border"></div>
        <div class="btn_border2" v-show="!btn_border"></div>
        <!-- 可用支付方式 -->
        <div style="width: 1000px;height: 60px;text-align: left;padding: 10px 30px;box-sizing: border-box;position: relative;">
          <el-image :src='paymentlogo' style="width: 400px;" />
          <el-image :src='yh' style="width: 34px;position: absolute;top: 13px;left: 176px;" />
        </div>
        <el-carousel trigger="click" height="475px" style="background-color: rgb(208, 233, 247);" arrow="never" ref="btnClick" :loop="false" :autoplay="false">
          <el-carousel-item>
            <Rotation :internal_goods_tableData="internal_goods_tableData" v-if="internal_goods_tableData.length>0" />
            <div v-else style="width: 100%;height: 100%;text-align: center;font-size: 44px;line-height: 400px;">敬请期待</div>
          </el-carousel-item>
          <el-carousel-item>
            <Rotation :internal_goods_tableData="commodity_tableData" v-if="commodity_tableData.length>0" />
            <div v-else style="width: 100%;height: 100%;text-align: center;font-size: 44px;line-height: 400px;">敬请期待</div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </nav>
    <!-- 底部信息展示模块 -->
    <div class="bottom">
      <div class="bottom_left">
        <div class="bottom_left_size">业务咨询</div>
        <div class="bottom_left_content">
          <div>邮储银行长春分行</div>
          <div>地址：长春市朝阳区西安大路336号安华大厦1楼</div>
          <div>电话：88969300</div>
        </div>
      </div>
      <div class="bottom_right">
        <div style="display: flex;flex-direction: column;justify-self: center;text-align: center;">
          <el-image :src="code1" style="width: 100px;height: 100px;" @error="srcerr2('code1',$event)" />
          信用卡申请
        </div>
        <div style="display: flex;flex-direction: column;line-height: 22px;text-align: center;">
          <el-image :src="code2" style="width: 100px;height: 100px;" @error="srcerr2('code2',$event)" />
          <span style="margin-top: 2px;">关注公众号</span>
        </div>
        <div style="display: flex;flex-direction: column;">
          <el-image :src="code3" style="width: 100px;height: 100px;text-align: center;" @error="srcerr2('code3',$event)" />
          手机银行下载
        </div>
      </div>

    </div>

    <!--抽福袋攻略弹窗-->
    <div style="position: absolute;bottom: 500px;left: 60px;width: 950px;height: 600px;z-index: 100" v-show="cfd_show">
      <div class="zzc_box"></div>
      <div style="width: 40px;height: 40px;position: absolute;z-index: 1000;right: 35px;top: 35px;" @click='cfd_show=false'></div>
      <el-image style="width: 950px;" :src="cfd" />
    </div>
    <!--微信扫码攻略弹窗-->
    <div style="position: absolute;bottom: 500px;left: 60px;width: 950px;height: 600px;z-index: 100" v-show="wxsm_show">
      <div class="zzc_box"></div>
      <div style="width: 40px;height: 40px;position: absolute;z-index: 1000;right: 35px;top: 35px;" @click='wxsm_show=false'></div>
      <el-image style="width: 950px;" :src="wxsm" />
    </div>
    <!--移动支付攻略弹窗-->
    <div style="position: absolute;bottom: 500px;left: 60px;width: 950px;height: 600px;z-index: 100" v-show="ydzf_show">
      <div class="zzc_box"></div>
      <div style="width: 40px;height: 40px;position: absolute;z-index: 1000;right: 35px;top: 35px;" @click='ydzf_show=false'></div>
      <el-image style="width: 950px;" :src="ydzf" />
    </div>
    <!--抽福袋弹窗-->
    <div style="position: absolute;bottom: 250px;left: 60px;width: 950px;height: 1400px;z-index: 100" v-show="activity_show">
      <div class="zzc_box"></div>
      <el-image style="width: 950px;height: 1400px;" :src="activity_background16" />
      <el-image style="width: 60px;height: 60px;position: absolute;top: 105px;right: 60px;" :src="activity_background_close" @click="activity_list_close" />
      <!--活动列表-->
      <el-carousel ref="nop" height="950px" direction="vertical" :autoplay="false" style="margin-top: -1000px;" class="new-item3 new-item4" v-show="activity_list_show">
        <el-carousel-item v-for="(item1 ,index1) in pic_item1" :key="index1">
          <div v-for="(item, i) in item1" :key="i" @click="luck_draw(item, i)" style="margin: 30px 0;position: relative">
            <v-touch class="v-touch" v-on:swipeup="next('',$event)" v-on:swipedown="prev('',$event)" style="height: 100%;">
              <el-image style="width: 644px;height: 133px;" :src="activity_background_list" v-if="item.lai_uuid!==undefined" />
              <div style="position: absolute;top: 6px;right: 190px;background: #a47158;color:#FFFFFF;padding: 5px 3px;border-radius: 5px" v-if="item.lai_waring==='2' && item.lai_start_time >data_id">距离活动开始:{{ item.time }}
              </div>
              <div style="position: absolute;top: 17px;left: 240px;height: 100px;color: #FFD8D8" v-if="item.lai_uuid!==undefined">
                <div style="width: 420px;height: 40px;font-size: 40px;line-height: 40px;" v-show="activity_id">
                  {{ item.lai_uuid }}
                </div>
                <div style="width: 420px;height: 40px;font-size: 40px;line-height: 40px;">{{ item.lai_caption }}</div>
                <div style="width: 420px;height: 14px;font-size: 14px;line-height: 14px;margin: 6px 0 3px 0">
                  {{ item.lai_start_time }}-{{ item.lai_end_time }}
                </div>
                <div style="width: 420px;height: 31px;font-size: 14px;line-height: 16px">活动简介：{{
                  item.lai_content
                  }}
                </div>
              </div>
            </v-touch>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div style="position: absolute;top: 360px;right: 115px;" v-show="activity_phone_show">
        <div style="font-size: 48px;font-weight: bold;color: #E28331;line-height: 48px;margin: 10px auto" v-if="this.lai_user_scope ==='2'">幸运福袋
        </div>
        <div style="font-size: 48px;font-weight: bold;color: #E28331;line-height: 48px;margin: 10px auto" v-if="this.lai_user_scope ==='1'">{{ this.lai_caption }}
        </div>
        <div style="width: 750px;height: 50px;position: relative">
          <div style="font-size: 30px;color: #FDAD55;position: absolute;top: 18px;left: 30px;" v-if="this.lai_user_scope ==='2'">操作说明
          </div>
          <el-image style="width: 700px;height: 110px;position: absolute;top: 80px;left: 30px;" :src="step1" v-show="step1_show" />
          <el-image style="width: 700px;height: 110px;position: absolute;top: 80px;left: 30px;" :src="step2" v-show="step2_show" />
          <el-image style="width: 700px;height: 110px;position: absolute;top: 80px;left: 30px;" :src="step3" v-show="step3_show" />
        </div>
        <div style="width: 700px;position: relative;">
          <el-form :model="phoneForm" :rules="phonerule" ref="phoneForm" v-if="this.lai_user_scope ==='2'">
            <el-form-item prop="phone" class="input2">
              <el-input placeholder="请输入手机号验证资格" v-model="phone" style="width: 400px;position: absolute;top: 160px;left: 120px;" class="input1" @focus="getKeyBoardPosition($event)"></el-input>
            </el-form-item>
            <div style="position: absolute;top: 160px;left: 520px;width: 130px;height: 71px;background: #fb9163;border-radius: 5px;font-size: 28px;line-height: 71px;color: #FFFFFF;" @click="submitForm()">验证
            </div>
          </el-form>
        </div>
        <div style="position: relative">
          <div style="font-size: 48px;line-height: 48px;color: #EEBF77;position: absolute;top: 100px;left: 60px" v-if="this.lai_user_scope ==='1'">请在工作人员陪同下进行抽奖
          </div>
          <div style="position: absolute;top: 230px;left: 270px" v-show="a1">
            <div style="font-size: 20px;color:red;line-height: 40px;" v-show="opportunity_show" v-if="this.lai_user_scope ==='2'">您有{{ this.total1>0?this.total1:0 }}次抽奖机会
            </div>
            <div style="font-size: 20px;color:red;line-height: 40px;margin-bottom: 10px" v-if="this.lai_user_scope ==='1' && this.number<='10'">还可以抽取{{ this.number }}次
            </div>
            <div style="font-size: 30px;line-height: 40px;color: #EEBF77">{{ this.tips }}</div>
          </div>
          <div style="position: absolute;top: 230px;left: 40px" v-show="a2">
            <div style="font-size: 20px;color:red;line-height: 40px" v-show="opportunity_show">{{ this.total2 }}</div>
            <div style="font-size: 30px;line-height: 40px;color: #EEBF77">{{ this.tips }}</div>
          </div>
          <div>
            <el-image style="width: 650px;height: 550px;position: absolute;top: 325px;left: 60px" :src="lock1" v-show="lessing_bag1" />
            <el-image style="width: 650px;height: 550px;position: absolute;top: 325px;left: 60px" :src="lock2" v-show="lessing_bag2" />
            <!--图1-->
            <div @click="User_lottery">
              <el-image class="cake" style="width: 130px;height: 130px;position: absolute;top: 375px;left: 128px" :src="lock3" v-show="lessing_bag2" />
            </div>
            <!--图2-->
            <div @click="User_lottery">
              <el-image class="cake" style="width: 130px;height: 130px;position: absolute;top: 375px;left: 326px" :src="lock3" v-show="lessing_bag2" />
            </div>
            <!--图3-->
            <div @click="User_lottery">
              <el-image class="cake" style="width: 130px;height: 130px;position: absolute;top: 375px;left: 522px" :src="lock3" v-show="lessing_bag2" />
            </div>
            <!--图4-->
            <div @click="User_lottery">
              <el-image class="cake" style="width: 130px;height: 130px;position: absolute;top: 538px;left: 128px" :src="lock3" v-show="lessing_bag2" />
            </div>
            <!--图5-->
            <div @click="User_lottery">
              <el-image class="cake" style="width: 130px;height: 130px;position: absolute;top: 538px;left: 326px" :src="lock3" v-show="lessing_bag2" />
            </div>
            <!--图6-->
            <div @click="User_lottery">
              <el-image class="cake" style="width: 130px;height: 130px;position: absolute;top: 538px;left: 522px" :src="lock3" v-show="lessing_bag2" />
            </div>
            <!--图7-->
            <div @click="User_lottery">
              <el-image class="cake" style="width: 130px;height: 130px;position: absolute;top: 701px;left: 128px" :src="lock3" v-show="lessing_bag2" />
            </div>
            <!--图8-->
            <div @click="User_lottery">
              <el-image class="cake" style="width: 130px;height: 130px;position: absolute;top: 701px;left: 326px" :src="lock3" v-show="lessing_bag2" />
            </div>
            <!--图9-->
            <div @click="User_lottery">
              <el-image class="cake" style="width: 130px;height: 130px;position: absolute;top: 701px;left: 522px" :src="lock3" v-show="lessing_bag2" />
            </div>
          </div>
        </div>
      </div>
      <!--中奖-->
      <div style="position: absolute;top: 400px;right: 73px;width: 800px" v-show="activity_prize_show">
        <div style="margin: 0 auto">
          <div v-if="this.prize !== '谢谢参与'" style="font-size: 80px;font-weight: 400;color: #FA9800;margin-left: 30px">
            恭喜您中奖了！
          </div>
          <div v-if="this.prize === '谢谢参与'" style="font-size: 60px;font-weight: 400;color: #FA9800;margin-left: 30px">
            很遗憾！与奖品擦肩而过！
          </div>
          <div style="font-size: 60px;font-weight: 400;color: #FA9800;margin: 30px 0 20px -20px">{{ this.prize }}</div>
          <div style="height: 500px;position: relative">
            <el-image style="width: 200px;height: 230px;position: absolute;top: 60px;left: 310px;z-index: 20" :src="blast" />
            <el-image style="width: 230px;height: 230px;position: absolute;top: 220px;left: 290px;z-index: 10" :src="box" />
          </div>
          <div style="color: #AEAEAE;font-size: 30px;margin: 20px 0">关闭倒计时：{{ this.count }}s</div>
          <div style="background: #FA9800;width: 250px;height: 80px;margin: 10px auto;border-radius: 10px">
            <div style="font-size: 30px;line-height: 80px;color: #FFFFFF" @click="once_more">再来一次</div>
          </div>
        </div>
      </div>
      <div class='zzc_box' style="z-index:1000;" v-if="activity_prize_show_box">
        <!-- <el-image style="width: 500px;height: 500px;position: absolute;top:calc(50% - 300px);left:calc(50% - 250px);"
          :src="dongtaifudai" /> -->

        <div style="width: 500px;height: 500px;position: absolute;top:calc(50% - 300px);left:calc(50% - 250px);" class="lottie"></div>
      </div>
    </div>
    <!--商品二维码页面-->
    <div style="position: absolute;bottom: 300px;left: 60px;width: 950px;z-index: 100" v-show="qr_code_show">
      <div class="zzc_box"></div>
      <el-image style="width: 950px;" :src="background_new" />
      <el-image style="width: 60px;height: 60px;position: absolute;top: 50px;right: 60px;" :src="commodity_on" @click="commodity_list_close12" />
      <div style="position: absolute;top: 170px;left: 80px;width: 800px">
        <div style="width: 750px;height: 300px;margin: 0 auto;">
          <div style="display: flex; width: 100%;height: 60%;justify-content: space-between;box-sizing: border-box;">
            <div>
              <el-image v-if="objMsg.mbgi_goods_img_path" style="width: 240px;height: 240px;" :src="objMsg.mbgi_goods_img_path" @error="srcerr(item,$event)" />
            </div>
            <div style="width: 400px;height: 100px; text-align: left; letter-spacing:4px">
              <div class="ellipsis" style="font-size: 34px;font-weight: bolder;font-style: normal;">
                {{objMsg.mbgi_goods_name}}</div>
              <div class="ellipsis" style="font-size: 30px;font-weight: 600;">
                品牌：{{objMsg.mbgi_goods_marker||''}}</div>
              <div class="ellipsis" style="font-size: 30px;font-weight: 600;">
                规格：{{objMsg.mbgi_goods_describer||''}}</div>
              <div class="ellipsis" style="font-size: 30px;font-weight: 600;">
                原价：<del style="letter-spacing:2px">￥{{objMsg.mbgi_money_1||''}}</del>元</div>
              <div style="display: flex;align-items: center;">
                <div style="display: flex;align-items: center;font-size: 30px;font-weight: 500;color: red;position: relative;left: -30px;">
                  <div v-show="codeShow">优惠价：</div>
                  <div v-show="!codeShow">特惠价：</div>￥
                  <div v-show="codeShow" style="font-size: 52px;letter-spacing:2px">{{ objMsg.mbgi_money_2}}</div>
                  <div v-show="!codeShow" style="font-size: 52px;letter-spacing:2px">{{ objMsg.mbgi_money_3}}</div>元
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex;">
          <div style="width: 60%;height:200px ; margin: 30px auto;text-align: center;">
            <div style="font-size: 30px;font-weight: 600;margin-left: 20px;letter-spacing:4px">请扫描下方二维码支付购买</div>
            <div v-if="cq_code1" :style="{'background-image': 'url('+frame_new+')'}" class="image_frame">
              <vue-qr style="width: 210px;height: 210px;" :text="img_commodity.msg" :margin="0" :logoScale="0.3" :size="200"></vue-qr>
            </div>
            <div v-if="cq_code2" :style="{'background-image': 'url('+frame_new+')'}" class="image_frame">
              <vue-qr style="width: 210px;height: 210px;" :text="img_commodity.msg" :margin="0" :logoScale="0.3" :size="200"></vue-qr>
            </div>
            <!-- 可用支付方式 -->
            <div style="width: 236px;height: 60px;text-align: left;padding: 10px 30px;box-sizing: border-box;margin: 0 auto;">
              <el-image :src='wx' style="width: 40px;" />
              <el-image :src='zfb' style="width: 40px;" />
              <el-image :src='ysf' style="width: 40px;" />
              <el-image :src='yh' style="width: 40px;" />
            </div>
            <div style="margin-top: 40px;">
              （{{count}}）
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--手机号页面-->
    <div style="position: absolute;bottom: 800px;left: 60px;width: 950px;height: 500px;z-index: 200;" v-if="commodity_phone_show">
      <div class="zzc_box"></div>
      <el-image style="width: 950px;height: 500px;" :src="box1" />
      <div style="position: absolute;top: 100px;left: 80px;width: 800px">
        <el-image style="width: 60px;height: 60px;position: absolute;top: -72px;right: -41px" :src="activity_background_close" @click="commodity_phone_close" />
        <div style="font-size: 46px;font-weight: 500;color: #333333;display: flex;align-items: center;justify-content: center;">
          <div>解锁</div>
          <el-image style="width: 151px;height: 94px;" :src="commodity_phone_size" />
          <div>价</div>
        </div>
        <div style="margin-top: 50px;display: flex">
          <div style="width: 500px;">
            <el-form :model="phoneForm" :rules="phonerule" ref="phoneForm">
              <el-form-item prop="phone" class="input2">
                <el-input placeholder="请输入手机号验证资格" v-model="phone" style="width: 400px;" class="input1" @focus="getKeyBoardPosition($event)"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <el-image style="width: 230px;height: 70px;border-radius: 15px;" :src="commodity_phone_but" @click="commodity_submitForm" />
        </div>
        <div v-show="phone_size1" style="font-size: 30px;color: #FDAD55">未获得特惠价购买资格，无法解锁</div>
        <div v-show="phone_size2" style="font-size: 30px;color: #FDAD55">
          上次解锁特惠价后支付超时，请在今天{{this.mbs_writetime_new}}后尝试解锁</div>
        <div style="font-size: 22px;position: absolute;top:300px;text-align: left;font-weight: 700;display: flex;">
          *<div style="margin-left: 20px;">
            特惠价位是银行网点为满足特定条件的客户提供的专属权益 <br>
            如验证无参加资格，请咨询网点人员详情
          </div>
        </div>
      </div>
    </div>
    <div style="position: absolute">
      <div class="simple-keyboard" style="position: fixed;z-index: 1000;top: 880px;left: 113px;" v-show="showKeyBoard">
      </div>
    </div>
    <!--支付成功页面-->
    <div style="position: absolute;bottom: 300px;left: 60px;width: 950px;z-index: 100" v-show="payment_show1">
      <div class="zzc_box"></div>
      <el-image style="width: 950px;" :src="commodity_back" />
      <el-image style="width: 60px;height: 60px;position: absolute;top: 42px;right: 52px;" :src="commodity_on" @click="commodity_list_close12" />
      <div style="position: absolute;top: 100px;left: 25px;width: 900px; height: 500px; text-align: center;letter-spacing: 10px;line-height: 70px;">
        <div style="font-size: 40px;margin: 40px 0 0;color: rgb(225, 143, 43);">支付成功!</div>
        <div style="font-size: 40px;color: rgb(225, 143, 43);">请在下方取物口取走商品</div>
        <el-image style="width: 300px;margin-top: 30px;" :src="equipment_new" />
      </div>
    </div>
    <!--支付失败页面-->
    <div style="position: absolute;bottom: 300px;left: 60px;width: 950px;z-index: 100" v-show="payment_show">
      <div class="zzc_box"></div>
      <el-image style="width: 950px;" :src="commodity_back" />
      <el-image style="width: 60px;height: 60px;position: absolute;top: 45px;right: 55px;" :src="commodity_on" @click="commodity_list_close12" />
      <div style="position: absolute;top: 100px;left: 25px;width: 900px; height: 500px; text-align: center;letter-spacing: 10px;">
        <div style="font-size: 48px;margin: 120px 0 0;color: rgb(225, 143, 43);line-height: 70px;">抱歉 出货故障了</div>
        <div style="font-size: 24px;font-weight: 300; color: rgb(225, 143, 43);margin-top: 20px;">请微信扫码添加客服办理退款 </div>
        <el-image style="width: 350px;height: 350px;margin-top: 80px;" :src="code4" />
        <!-- <div style="font-size: 24px;font-weight: 300; color: rgb(225, 143, 43);margin-top: 20px;">您可以凭兑换码到指定位置供应商处 <br>
          兑换商品<br>兑换码长期有效 </div>
        <div class="btn_big" @click="bigBtnClick">立即获取兑换码 <br><span
            style="font-size: 20px;font-weight: normal;line-height: 20px;position: relative;top: -60px;">（{{timer_second}}s）</span>
        </div> -->
      </div>
    </div>
    <!--支付失败 商品详情页面-->
    <div style="position: absolute;bottom: 300px;left: 60px;width: 950px;z-index: 100" v-show="details_page_show">
      <div class="zzc_box"></div>
      <el-image style="width: 950px;" :src="commodity_back" />
      <el-image style="width: 60px;height: 60px;position: absolute;top: 45px;right: 55px;" :src="commodity_on" @click="commodity_list_close12" />
      <div style="position: absolute;top: 170px;left: 80px;width: 800px">
        <div style="width: 750px;height: 250px;margin: 0 auto;">
          <div style="display: flex; width: 100%;height: 60%;justify-content: space-between;box-sizing: border-box;">
            <div>
              <el-image v-if="objMsg.mbgi_goods_img_path" style="width: 240px;height: 240px;" :src="objMsg.mbgi_goods_img_path" @error="srcerr(item,$event)" />
            </div>
            <div style="width: 400px;height: 100px; text-align: left; letter-spacing:4px">
              <div class="ellipsis" style="font-size: 34px;font-weight: bolder;font-style: normal;">
                {{objMsg.mbgi_goods_name}}</div>
              <div class="ellipsis" style="font-size: 30px;font-weight: 600;">
                品牌：{{objMsg.mbgi_goods_marker||''}}</div>
              <div class="ellipsis" style="font-size: 30px;font-weight: 600;">
                规格：{{objMsg.mbgi_goods_describer||''}}</div>
              <div class="ellipsis" style="font-size: 30px;font-weight: 600;">
                原价<del style="letter-spacing:2px">：￥{{objMsg.mbgi_money_1||''}}</del>元</div>
              <div style="display: flex;align-items: center;">
                <div style="display: flex;align-items: center;font-size: 30px;font-weight: 500;color: red;position: relative;left: -30px;">
                  <div v-show="codeShow">优惠价：</div>
                  <div v-show="!codeShow">特惠价：</div>￥
                  <div v-show="codeShow" style="font-size: 52px;letter-spacing:2px">{{ objMsg.mbgi_money_2}}</div>
                  <div v-show="!codeShow" style="font-size: 52px;letter-spacing:2px">{{ objMsg.mbgi_money_3}}</div>元
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :style="{'background-image': 'url('+code_new+')'}" class="image_frame1">
          <div style="width: 500px;position: relative;">
            <div style="text-align: center;margin-top:10px; font-size: 40px;letter-spacing: 12px;color: #ffffff;">
              2{{billNo}}</div>
            <div style="text-align: left;margin-top: 110px; font-size: 30px;letter-spacing: 12px;">
              {{objMsg.objMsg_company}}</div>
            <div style="text-align: left;font-size: 30px;letter-spacing: 12px;">{{objMsg.objMsg_address}}</div>
            <div style="font-size: 20px;position: absolute;top: 310px;left: 230px;">
              （{{timer_second}}s）</div>
          </div>
        </div>
        <div style="margin-top: 0px;font-size: 30px;font-weight: 900;letter-spacing: 10px;">
          <span style="color: red;font-size: 44px;">!</span> 请手机拍照留存到商家兑换时出示
        </div>
      </div>
    </div>
    <!--优惠价支付提示-->
    <div style="position: absolute;bottom: 500px;left: 60px;width: 950px;z-index: 100" v-show="tipsShow">
      <div class="zzc_box"></div>
      <el-image style="width: 950px;" :src="commodity_back_new" />
      <el-image style="width: 60px;height: 60px;position: absolute;top: 30px;right: 30px;cursor: pointer;" :src="commodity_on" @click="commodity_list_close12" />
      <div style="position: absolute;top: 80px;width: 900px;left: 25px;">
        <div style="font-size: 70px;font-weight: 500;letter-spacing: 12px;">温馨提示</div>
        <div style="font-size: 36px;font-weight: 900;letter-spacing: 4px;text-align: left;margin-top: 50px;">
          本商品实际交付地点/方式如下:</div>
        <div style="font-size: 36px;font-weight: 900;letter-spacing: 4px;text-align: left;margin:30px 0 0 90px;min-height: 54px;">
          {{objMsg.objMsg_company}}</div>
        <div style="font-size: 36px;font-weight: 900;letter-spacing: 4px;text-align: left;margin:35px 0 0 90px;min-height: 54px;">
          {{objMsg.objMsg_address}}</div>
        <div style="font-size: 36px;font-weight: 900;letter-spacing: 4px;text-align: left;margin:35px 0 0">
          成功购买商品后凭<span style="color: red;font-size: 42px;font-weight: 400;">拍照留存</span>的 “<span style="color: red;font-size: 42px;font-weight: 400;">兑换码</span>” 到上方地点兑换产品/服务
        </div>
        <div class="big_btn" @click='qr_code_but_click(ObjData.item, ObjData.i)'>朕已知晓，继续吧 <br><span style="font-size: 20px;font-weight: normal;line-height: 20px;position: relative;top: -70px;">（{{timer_second}}s）</span>
        </div>
      </div>
    </div>
    <!--设备外支付成功提示-->
    <div style="position: absolute;bottom: 300px;left: 60px;width: 950px;z-index: 100" v-show="payment_show_Tips">
      <div class="zzc_box"></div>
      <el-image style="width: 950px;" :src="commodity_back" />
      <div style="position: absolute;top: 80px;width: 900px;left: 25px;">
        <div style="font-size: 90px;font-weight: 500;letter-spacing: 12px;margin-top: 70px;color: rgb(240, 163, 83);">
          支付成功</div>
        <div style="font-size: 36px;font-weight: 900;letter-spacing: 4px;margin-top: 50px;">请确保一米范围内无他窥视 <br>点击下方按钮获取兑换码
          <br>并拍照留存
        </div>
        <div class="big_btn" style="margin-top: 120px;" @click='qr_code_but_new()'>朕已确认，立刻获取<br><span style="font-size: 20px;font-weight: normal;line-height: 20px;position: relative;top: -70px;">（{{timer_second}}s）</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Keyboard from 'simple-keyboard';
import 'simple-keyboard/build/css/index.css';
import vueQr from 'vue-qr';
import Rotation from '../../components/Rotation.vue';
import es6 from '@/assets/js/custom_es6.js'
import lottie from "lottie-web";  // 引入插件
import animationData from "@/assets/js/8362-lottery-whirl.json";   // 引入json 数据
export default {
  components: {
    vueQr, Rotation
  },
  name: "defaultIndex",
  props: {
    pri_detail: {
      type: Object,
      default: function () {
        return {
          activityObj: {},
        }
      }
    }
  },
  data () {
    // let phone = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('手机号不能为空'))
    //   } else if (!this.isCellPhone(value)) {
    //     callback(new Error('请输入正确的手机号!'))
    //   } else {
    //     callback()
    //   }
    // };
    return {
      pageShow: false,
      btn_border: true,
      timer_new: '',
      timer_newTime: '',
      commodity_data1: [],
      cfd_show: false,
      payment_show_Tips: false,
      tipsShow: false,
      details_page_show: false,
      wxsm_show: false,
      ydzf_show: false,
      cfd: require("@/assets/images/CFD.png"),
      wxsm: require("@/assets/images/WXSM.png"),
      ydzf: require("@/assets/images/YDZF.png"),
      gl: require("@/assets/images/GL.png"),
      gl1: require("@/assets/images/GL1.png"),
      s: require("@/assets/images/S.gif"),
      ljcy: require("@/assets/images/LJCY.gif"),
      ljcy1: require("@/assets/images/ljcy.png"),
      img_data: [],
      payment_show1: false,
      code_img_data: [],
      business_data: [],
      business_data1: [],
      bdbi_path: '',
      banner: require("@/assets/images/banner1.png"),
      dd: require("@/assets/images/dd.png"),
      rmb: require("@/assets/images/rmb.png"),
      fd: require("@/assets/images/fd.png"),
      box_img1: require("@/assets/images/fudai.png"),
      box_img2: require("@/assets/images/qian.png"),
      size1: require("@/assets/images/xiang.png"),
      bank_business1: require("@/assets/images/xinyongka.png"),
      bank_business1_code: require("@/assets/images/code.png"),
      bank_business2: require("@/assets/images/chuxuka.png"),
      bank_business3: require("@/assets/images/vip.png"),
      size2: require("@/assets/images/shifan.png"),
      defaultImg1: require("@/assets/images/left.png"),
      defaultImg2: require("@/assets/images/right.png"),
      foot_img: require("@/assets/images/foot_img.png"),
      yh: require("@/assets/images/yh.png"),
      zfb: require("@/assets/images/zfb.png"),
      wx: require("@/assets/images/wx.png"),
      ysf: require("@/assets/images/ysf.png"),
      activity_background: require("@/assets/images/activity_background.png"),
      activity_background_close: require("@/assets/images/close.png"),
      paymentlogo: require("@/assets/images/paymentlogo.png"),
      activity_background_list: require("@/assets/images/activity_list.png"),
      step1: require("@/assets/images/step1.png"),
      step2: require("@/assets/images/step2.png"),
      step3: require("@/assets/images/step3.png"),
      lock1: require("@/assets/images/lock1.png"),
      lock2: require("@/assets/images/lock2.png"),
      lock3: require("@/assets/images/fudai_1.png"),
      blast: require("@/assets/images/blast.png"),
      dongtaifudai: require("@/assets/images/dongtaifudai.gif"),
      box: require("@/assets/images/box.png"),
      commodity_back: require("@/assets/images/commodity_back.png"),
      commodity_back_new: require("@/assets/images/commodity_back_new.png"),

      frame_new: require("@/assets/images/frame_new.png"),
      equipment_new: require("@/assets/images/equipment_new.png"),
      code_new: require("@/assets/images/code_new.png"),
      background_new: require("@/assets/images/background_new.png"),

      commodity_on: require("@/assets/images/commodity_on.png"),
      commodity_size2: require("@/assets/images/commodity_size2.png"),
      commodity_code: require("@/assets/images/code.png"),
      commodity_size: require("@/assets/images/commodity_size.png"),
      commodity_state: require("@/assets/images/commodity_state.png"),
      commodity_but: require("@/assets/images/commodity_but.png"),
      commodity_phone_size: require("@/assets/images/commodity_phone_size.png"),
      commodity_phone_but: require("@/assets/images/commodity_phone_but.png"),
      code1: require("@/assets/images/code1.png"),
      code2: require("@/assets/images/code2.png"),
      code3: require("@/assets/images/code3.png"),
      code4: require("@/assets/images/code4.png"),
      box_i: require("@/assets/images/box_i.png"),
      prizeBag: require("@/assets/images/prizeBag.png"),
      digitalCurrency: require("@/assets/images/digitalCurrency.png"),
      box1: require("@/assets/images/box1.png"),
      box_img: require("@/assets/images/box_img.png"),
      label1: require("@/assets/images/label.png"),
      more1: require("@/assets/images/more.png"),
      shop_title: require("@/assets/images/shop_title.png"),
      activity_show: false,
      tableData: [],
      activity_id: false,
      activity_list_show: true,
      activity_phone_show: false,
      activity_prize_show: false,
      activity_prize_show_box: false,
      step1_show: true,
      step2_show: false,
      step3_show: false,
      phone: '',
      phonerule: {
        // phone: [
        //   {required: true, validator: phone, trigger: 'blur'}
        // ],
      },
      opportunity_show: false,
      lai_uuid: '',
      lai_user_scope: '',
      total1: '',
      total2: '',
      tips: '',
      a1: true,
      a2: false,
      lessing_bag1: false,
      lessing_bag2: false,
      pic_item1: [],
      type: '',
      lai_caption: '',
      prize: '',
      count: "",//倒计时
      money: '',
      keyboard: null,
      keyboard1: null,
      keyboardClass: 'simple-keyboard',
      showKeyBoard: false,
      number_tableData: [],
      number: '',
      data_time1: '',
      data_time2: '',
      data_time3: '',
      tableData1: [],
      data_id: '',
      phoneForm: {},
      commodity_show: false,
      qr_code_show: false,
      codeShow: true,
      commodity_tableData1: [],
      commodity_tableData: [],
      internal_goods_tableData1: [],
      internal_goods_tableData: [],
      commodity_data: [],
      internal_goods_data: [],
      transcoding_id: '',//转码
      billNo: '',//订单号
      img_commodity: {
        msg: '',
        billNo: '',
      },
      commodity_data_id: '',//当前日期
      count1: '',
      timer: null,
      timer1: null,
      ObjData: {},
      objMsg: {
        mbgi_goods_img_path: "https://pre.borunxinke.com//fr/imgserver/13074348889//20220510113617427.png",
        A: 3,
        gbs_device_uuid: "DEV_20220425_201235923_108181985",
        gbs_goods_type_uuid: "MGI_20220510_113618860_109639407",
        gbs_number: "1",
        gbs_uuid: "GBS_20220621_145320226_108782406",
        gbs_writetime: "2022-06-21 14:53:20",
        mbgi_bank_center_id: "CEN_20220425_141840107_104330753",
        mbgi_check_status: "1",
        mbgi_city_id: "CIT_20220425_142042339_104268422",
        mbgi_county_id: "COU_20220425_142129766_106685678",
        mbgi_cui_id: "USE_20220425_144215712_104171330",
        mbgi_del_status: "1",
        mbgi_goods_alias_name: "蛇皮果",
        mbgi_goods_describer: "大果",
        mbgi_goods_marker: "123",
        mbgi_goods_name: "蛇皮果",
        mbgi_mer_uuid: "MMI_20220425_142247293_105327771",
        mbgi_money_1: "10",
        mbgi_money_2: "1",
        mbgi_money_3: "0.1",
        mbgi_province_id: "PRO_20220425_141942955_108545325",
        mbgi_sale_mode: "1",
        mbgi_show: "1",
        mbgi_source: "1",
        mbgi_station_id: "STA_20220425_142212671_109421338",
        mbgi_status: "2",
        mbgi_uuid: "MGI_20220510_113618860_109639407",
        mbgi_writetime: "2022-05-10 11:36:18",
        mdgi_bank_center_id: "CEN_20220425_141840107_104330753",
        mdgi_city_id: "CIT_20220425_142042339_104268422",
        mdgi_county_id: "COU_20220425_142129766_106685678",
        mdgi_device_uuid: "DEV_20220425_201235923_108181985",
        mdgi_goods_pay_status: "1",
        mdgi_goods_type_uuid: "MGI_20220510_113618860_109639407",
        mdgi_mer_uuid: "MMI_20220425_142247293_105327771",
        mdgi_number: "1",
        mdgi_province_id: "PRO_20220425_141942955_108545325",
        mdgi_station_id: "STA_20220425_142212671_109421338",
        mdgi_status: "1",
        mdgi_uuid: "DPI_20220620_164910452_102132622",
        mdgi_writetime: "2022-06-20 16:49:10",
        objMsg_address: "松柏路3232号",
        objMsg_company: "松柏路支行",
      },
      mbgi_goods_name: '',//商品名称
      mbgi_money_3: '',//商品特惠价
      commodity_phone_show: false,//手机号开关
      phone_size1: false,//验证手机号后解锁没机会
      phone_size2: false,//验证手机号后解锁超时
      mau_uuid_new: '',//手机号验证成功取得参数
      cq_code1: false,//二维码
      cq_code2: false,//二维码
      count3: '',//解锁中的时间
      mbs_writetime_new: '',//手机号验证成功取得参数
      count_time: '',//列表定时器
      timer3: '',
      timer4: '',
      payment_show: false,//支付页面开关
      timer_second: 10,//支付页面开关
    }
  },
  created: function () {
    console.info("活动对象：" + JSON.stringify(this.pri_detail.activityObj));
    this.customMethod('1');
  },
  provide () {
    return {
      qr_code_but: this.qr_code_but,
      phone_but: this.phone_but,
      commodity_payment: this.commodity_payment,
    }
  },
  watch: {
    payment_show (newShow) {
      if (newShow) {
        this.timer_second = 15
        this.timer_new = setInterval(() => {
          if (this.timer_second == 0) {
            this.timer_second = 10
            this.commodity_list_close12()
            clearInterval(this.timer_new)
            this.timer_new = ''
          } else {
            this.timer_second--
          }
        }, 1000);
      }
    },
    commodity_phone_show (newShow) {
      if (newShow) {
        this.timer_second = 30
        this.timer_new = setInterval(() => {
          if (this.timer_second == 0) {
            this.timer_second = 10
            this.commodity_list_close12()
            clearInterval(this.timer_new)
            this.timer_new = ''
          } else {
            this.timer_second--
          }
        }, 1000);
      }
    },
    payment_show1 (newShow) {
      if (newShow) {
        this.timer_newTime = setTimeout(() => {
          clearTimeout(this.timer_newTime)
          this.timer_newTime = ''
          this.payment_show1 = false
          this.commodity_list_close12()
        }, 10000);
      } else {
        clearTimeout(this.timer_newTime)
        this.timer_newTime = ''
      }
    },
    details_page_show (newShow) {
      if (newShow) {
        this.timer_second = 30
        this.timer_new = setInterval(() => {
          if (this.timer_second == 0) {
            this.timer_second = 10
            this.commodity_list_close12()
            clearInterval(this.timer_new)
            this.timer_new = ''
          } else {
            this.timer_second--
          }
        }, 1000);
      }
    },
    payment_show_Tips (newShow) {
      if (newShow) {
        this.timer_second = 15
        this.timer_new = setInterval(() => {
          if (this.timer_second == 0) {
            this.timer_second = 10
            this.commodity_list_close12()
            clearInterval(this.timer_new)
            this.timer_new = ''
          } else {
            this.timer_second--
          }
        }, 1000);
      } else {
        clearInterval(this.timer_new)
        this.timer_new = ''
      }
    },
    tipsShow (newShow) {
      if (newShow) {
        this.timer_second = 15
        this.timer_new = setInterval(() => {
          if (this.timer_second == 0) {
            this.timer_second = 10
            this.commodity_list_close12()
            clearInterval(this.timer_new)
            this.timer_new = ''
          } else {
            this.timer_second--
          }
        }, 1000);
      }
    },
    // qr_code_show (newShow) {
    //   if (!newShow) {
    //     this.$refs.vueQr.remove()
    //   }
    // },
    money (input) {
      this.keyboard.setInput(input);

    },
    phone (input, newInput) {
      this.keyboard.setInput(input);
      this.phone = input.length > 11 ? input.slice(0, 11) : input
    },
  },
  mounted () {
    // document.addEventListener("click", this.hideKeyBoard);
    this.keyboard = new Keyboard(this.keyboardClass, {
      onChange: this.onChange,
      onKeyPress: this.onKeyPress
    });
    this.setKeyboard();
    window['customMethod'] = val => {
      this.customMethod(val)
    }
  },
  methods: {
    // json动图展示
    optAnimation () {
      lottie.destroy();
      this.$nextTick(() => {
        let elem = document.querySelector(".lottie")
        let params = {
          container: elem,
          renderer: "svg",
          loop: true,
          autoplay: true,
          animationData: animationData,
        };
        lottie.loadAnimation(params);
      });
    },
    //切换设备内设备外商品列表
    btnClick (key, val) {
      console.log('key==', key, '---------------------------------------------------------');
      switch (key) {
        case 1:
          console.log('key==', key, '---------------------------------------------------------');
          this.btn_border = true
          break;
        case 2:
          console.log('key==', key, '---------------------------------------------------------');
          this.btn_border = false
          break;
      }
      if (val === "right") {
        this.$refs.btnClick.next();
      } else {
        this.$refs.btnClick.prev();
      }

    },
    qr_code_but_new () {
      this.timer_second = 10
      clearInterval(this.timer_new)
      this.timer_new = ''
      this.payment_show_Tips = false
      this.details_page_show = true
    },
    customMethod: function (args) {
      this.commodity_list_select();
      this.commodity_list_select1();
      this.internal_goods_list_select();
      this.img_select();
      switch (args) {
        case '1':
          this.commodity_list_select();
          this.commodity_list_select1();
          this.internal_goods_list_select();
          break;
        case '2':
          this.payment_show1 = true
          this.payment_show = false
          this.qr_code_show = false;
          this.count = '';
          this.clearTime();
          clearInterval(this.timer1);
          clearInterval(this.timer5);
          this.timer5 = null;
          this.$message('出货成功');
          console.log('出货成功');
          break;
        case '3':
          this.payment_show1 = false
          this.payment_show = true
          this.qr_code_show = false;
          this.count = '';
          this.clearTime();
          clearInterval(this.timer1);
          clearInterval(this.timer5);
          this.timer5 = null;
          this.$message('出货失败');
          console.log('出货失败', '---');
          break;
        case '4':
          this.business_select()
          break;
      }
      console.info('args:' + args);

    },

    bigBtnClick () {
      this.payment_show = false
      this.details_page_show = true
      this.timer_second = 10
      clearInterval(this.timer_new)
      this.timer_new = ''
    },
    //图片加载失败循环加载
    srcerr: function (item, e) {
      let path = item.mbgi_goods_img_path;
      console.info("error img path:" + path);
      e.target.src = item.mbgi_goods_img_path;

    },
    //图片加载失败循环加载
    srcerr2: function (item, e) {
      this.code1 = require("@/assets/images/code1.jpg"),
        this.code2 = require("@/assets/images/code2.jpg"),
        this.code3 = require("@/assets/images/code3.png"),
        e.target.src = this[item]
    },
    srcerr1: function (item, e) {

      let path = item.bdbi_path;
      console.info("error img path:" + path);
      e.target.src = item.bdbi_path;

    },
    onChange: function (input) {
      console.log("Input changed", input);
      // this.money = input;
      this.phone = input;
    },

    onKeyPress: function (button) {
      console.log("Button pressed", button);
      this.timer_second = 30
      if (button === '{enter}') {
        console.log("Button pressed------------------", button);
        this.showKeyBoard = false;
      }
    },
    setKeyboard () {
      this.keyboard.setOptions({
        layoutName: "default",//
        //theme: "hg-theme-default hg-layout-default myTheme",
        layout: {
          default: ["1 2 3", "4 5 6", "7 8 9", "{enter} 0 {bksp}"],

        },
        buttonTheme: [
          {
            class: "bksp",
            buttons: "{bksp}"
          },
          {
            class: "enter",
            buttons: "{enter}"
          }
        ],
        display: {
          '{bksp}': "删除",
          '{enter}': "关闭"
        }
      });
    },
    getKeyBoardPosition (e) {
      // this.phone ='';
      this.showKeyBoard = true;
    },

    prev (txt, e) {
      e.preventDefault();
      console.info("" + txt);
      this.$refs.nop.prev();

    },
    next (txt, e) {
      e.preventDefault();
      console.info("" + txt);
      this.$refs.nop.next();

    },
    //数组重组
    formatArray: function (arr, num) {
      var newArray = new Array(Math.ceil(arr.length / num));
      for (var i = 0; i < newArray.length; i++) {
        newArray[i] = [];
        // for (var j = 0; j < num; j++) {
        //   newArray[i][j] = {};
        // }
      }
      for (var i = 0; i < arr.length; i++) {
        newArray[parseInt(i / num)][i % num] = arr[i];
      }
      return newArray;
    },
    /** 电话号校验 */
    isCellPhone (val) {
      if (!/^1(3|4|5|6|7|8)\d{9}$/.test(val)) {
        return false
      } else {
        return true
      }
    },
    activity_list () {
      this.activity_show = true;
      this.activity_list_show = true;
      this.activity_phone_show = false;
      this.activity_prize_show = false;
      this.pic_item1 = [];
      this.showKeyBoard = false;
      this.activity_list_select();
      this.startDivi();
    },
    activity_list_close () {
      this.showKeyBoard = false;
      this.activity_show = false;
      this.clearTime();
    },
    activity_list_select () {
      let that = this;
      let _jsondata_ = {
        lai_bank_center_id: that.pri_detail.activityObj.bank_center_id,
        lai_province_id: that.pri_detail.activityObj.province_id,
        lai_city_id: that.pri_detail.activityObj.city_id,
        lai_county_id: that.pri_detail.activityObj.county_id,
        lai_station_id: that.pri_detail.activityObj.station_id,
        lai_detail_status: '1',
        lai_waring: '1',
        perPageSize: 20,
        currentPage: 1,
      };
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)'
      });
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.Sweepstakes_Activities_select,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      a1.then((res) => {
        if (res.data.status == 'success') {
          loading.close();
          that.tableData = res.data.rows;
          var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
          var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
          var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
          var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
          var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
          var data_id = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
          console.log("当前时间：" + data_id)
          that.data_id = data_id;
          var _tmp1_ = [];
          that.tableData.forEach(function (item, index) {
            that.data_time1 = that.customGlobal.getDateTimeToTimestamp(item.lai_start_time)
            that.data_time3 = that.customGlobal.getDateTimeToTimestamp(data_id)


            if (that.data_time1 > that.data_time3) {
              // that.tableData.splice(index,1)
              console.log("删除开始时间:" + that.data_time1)
              console.log("删除当前时间：" + that.data_time3)
              console.log("item:" + JSON.stringify(item))
            } else {
              console.log("保留开始时间:" + that.data_time1)
              console.log("保留当前时间：" + that.data_time3)
              _tmp1_.push(item);
            }
          })
          if (_tmp1_ !== []) {
            that.tableData = _tmp1_;
          }
          console.log("table:" + JSON.stringify(that.tableData))
          that.activity_list_select1();
        } else {
          console.info("活动查询失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(error.message), '活动查询出错!', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '活动查询出错', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      });
    },
    activity_list_select1 () {
      let that = this;
      let _jsondata_ = {
        lai_bank_center_id: that.pri_detail.activityObj.bank_center_id,
        lai_province_id: that.pri_detail.activityObj.province_id,
        lai_city_id: that.pri_detail.activityObj.city_id,
        lai_county_id: that.pri_detail.activityObj.county_id,
        lai_station_id: that.pri_detail.activityObj.station_id,
        lai_detail_status: '1',
        lai_waring: '2',
        perPageSize: 20,
        currentPage: 1,
      };
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)'
      });
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.Sweepstakes_Activities_select,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      a1.then((res) => {
        if (res.data.status == 'success') {
          loading.close();
          that.tableData1 = [];
          that.pic_item1 = [];
          that.tableData1 = res.data.rows;
          that.tableData1.forEach(function (item, index) {
            var tab = that.tableData.push(item)
            console.log("that.tableData：" + JSON.stringify(that.tableData))
            // console.log("item：" + JSON.stringify(item))
            console.log("tab：" + JSON.stringify(tab))
          })
          that.pic_item1 = this.formatArray(that.tableData, 5);
          var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
          var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
          var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
          var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
          var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
          var data_id = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
          console.log("当前时间：" + data_id)
          that.pic_item1.forEach(function (item, index) {
            item.forEach(function (item1, index1) {
              console.log(item1.lai_start_time)
              if (item1.lai_start_time > data_id) {
                that.data_time1 = that.customGlobal.getDateTimeToTimestamp(item1.lai_start_time)
                that.data_time3 = that.customGlobal.getDateTimeToTimestamp(data_id)
                that.data_time2 = that.customGlobal.getTimestampToDateTime((that.customGlobal.getDateTimeToTimestamp(item1.lai_start_time) - item1.lai_waring_time * 84600 * 1000))
                // console.log("that.data_time1:"+that.data_time1)
                // console.log("that.data_time2:"+that.data_time2)
                // console.log("that.data_time3:"+that.data_time3)
                var time_id = that.data_time1 - that.data_time3;
                console.log("time_id:" + time_id)
                var days = Math.floor(time_id / (24 * 3600 * 1000));
                //计算出小时数
                var leave1 = time_id % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
                var hours = Math.floor(leave1 / (3600 * 1000));
                //计算相差分钟数
                var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
                var minutes = Math.floor(leave2 / (60 * 1000));
                var dayStr = days == 0 ? "" : days + "天";
                var hoursStr = hours == 0 ? "" : hours + "时";
                var time = dayStr + hoursStr + minutes + "分";
                console.log("time:" + time)


                item1.time = time;
              }
            })
          })
        } else {
          console.info("活动查询失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(error.message), '活动查询出错!', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '活动查询出错', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      });
    },
    luck_draw (item, i) {
      this.clearTime();
      if (item.time === undefined) {
        console.log(item.lai_uuid);
        this.lai_uuid = item.lai_uuid;
        this.lai_user_scope = item.lai_user_scope;
        this.lai_caption = item.lai_caption;
        if (this.lai_user_scope === '2') {
          this.activity_list_show = false;
          this.activity_phone_show = true;
          this.opportunity_show = false;
          this.activity_prize_show = false;
          this.phone = '';
          this.tips = '验证通过后开启';
          this.a2 = false;
          this.a1 = true;
          this.step1_show = true;
          this.step2_show = false;
          this.lessing_bag1 = true;
          this.lessing_bag2 = false;
          this.startDivi1();
        } else if (this.lai_user_scope === '1') {
          this.activity_list_show = false;
          this.activity_phone_show = true;
          this.activity_prize_show = false;
          this.phone = '';
          this.opportunity_show = false;
          this.tips = '选择下方任意福袋';
          this.a2 = false;
          this.a1 = true;
          this.step1_show = false;
          this.step2_show = false;
          this.lessing_bag1 = false;
          this.lessing_bag2 = true;
          this.number_of_prizes_select();
          this.startDivi();
        }
      } else if (item.time !== undefined) {
        this.$alert('活动未开始', '活动状态提示', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      }
    },
    //表单提交
    submitForm () {
      this.showKeyBoard = false;
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //     this.submitForm_select();
      //   } else {
      //     return false;
      //   }
      // });
      this.submitForm_select();
    },
    //不输入手机号抽奖
    submitForm_select () {
      let that = this;
      let _jsondata_ = {
        obj_bank_center_id: that.pri_detail.activityObj.bank_center_id,
        obj_province_id: that.pri_detail.activityObj.province_id,
        obj_city_id: that.pri_detail.activityObj.city_id,
        obj_county_id: that.pri_detail.activityObj.county_id,
        obj_station_id: that.pri_detail.activityObj.station_id,
        lub_aci_uuid: that.lai_uuid,
        lub_guest_phone: that.phone
      };
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)'
      });
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.Number_user_phone,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      a1.then((res) => {
        if (res.data.status == 'success') {
          loading.close();
          this.opportunity_show = true;
          if (res.data.remaining_opportunities > -1) {
            this.a2 = false;
            this.a1 = true;
            this.step1_show = false;
            this.step2_show = true;
            this.tips = '请选择下方任意福袋';
            this.lessing_bag1 = false;
            this.lessing_bag2 = true;
            this.total1 = res.data.remaining_opportunities;
            this.clearTime();
            this.startDivi();
          } else if (res.data.remaining_opportunities == -1) {
            this.step2_show = false;
            this.step1_show = true;
            this.a1 = false;
            this.a2 = true;
            this.lessing_bag1 = true;
            this.lessing_bag2 = false;
            this.total2 = '当前手机号无参与资格，请确认手机号是否正确或联系工作人员获取参与资格';
            this.tips = '验证通过后开启';
          }

        } else {
          console.info("手机号查询失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(error.message), '手机号查询出错!', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '手机号查询出错', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      });
    },
    //不输入手机号抽奖
    submitForm_select1 () {
      let that = this;
      let _jsondata_ = {
        obj_bank_center_id: that.pri_detail.activityObj.bank_center_id,
        obj_province_id: that.pri_detail.activityObj.province_id,
        obj_city_id: that.pri_detail.activityObj.city_id,
        obj_county_id: that.pri_detail.activityObj.county_id,
        obj_station_id: that.pri_detail.activityObj.station_id,
        lub_aci_uuid: that.lai_uuid,
        lub_guest_phone: that.phone
      };
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)'
      });
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.Number_user_phone,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      a1.then((res) => {
        if (res.data.status == 'success') {
          loading.close();
          this.opportunity_show = true;

        } else {
          console.info("手机号查询失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(error.message), '手机号查询出错!', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '手机号查询出错', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      });
    },
    //用户抽奖
    User_lottery () {
      if (this.lai_user_scope === '2') {
        this.type = '1';
      } else if (this.lai_user_scope === '1') {
        this.phone = '';
        this.type = '2'
      }
      let that = this;
      let _jsondata_ = {
        lai_uuid: that.lai_uuid,
        lai_bank_center_id: that.pri_detail.activityObj.bank_center_id,
        lai_province_id: that.pri_detail.activityObj.province_id,
        lai_city_id: that.pri_detail.activityObj.city_id,
        lai_county_id: that.pri_detail.activityObj.county_id,
        lai_station_id: that.pri_detail.activityObj.station_id,
        lau_guest_phone: that.phone,
        type: this.type,
      };
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)'
      });
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.User_lottery,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      a1.then((res) => {
        if (res.data.status == 'success') {
          loading.close();
          that.activity_list_show = false;
          that.activity_phone_show = false;
          ;
          // that.dongtaifudai=require("@/assets/images/dongtaifudai.gif")+'?'+Math.random(),
          that.activity_prize_show_box = true;
          this.optAnimation()
          this.timer_gif = setInterval(() => {
            that.activity_prize_show_box = false;
            that.activity_prize_show = true;
            clearInterval(this.timer_gif);
            this.timer_gif = null
          }, 4000)

          that.prize = res.data.msg;
          that.clearTime();
          that.startDivi();
        } else {
          console.info("用户抽奖失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(error.message), '用户抽奖出错!', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '用户抽奖出错', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      });
    },
    once_more () {
      if (this.lai_user_scope === '2') {
        this.step1_show = true;
        this.activity_list_show = false;
        this.activity_phone_show = true;
        this.activity_prize_show = false;
        this.step2_show = false;
        this.lessing_bag1 = true;
        this.lessing_bag2 = false;
        this.a2 = false;
        this.a1 = true;
        this.opportunity_show = false;
        this.submitForm_select();
        this.clearTime();
      } else if (this.lai_user_scope === '1') {
        this.step1_show = false;
        this.activity_list_show = false;
        this.activity_phone_show = true;
        this.activity_prize_show = false;
        this.step2_show = false;
        this.lessing_bag1 = false;
        this.lessing_bag2 = true;
        this.a2 = false;
        this.a1 = true;
        this.opportunity_show = false;
        this.submitForm_select1();
        this.clearTime();
        this.number_of_prizes_select();
      }
      this.startDivi();
    },
    //清除定时器
    clearTime () {
      clearInterval(this.timer);
      this.count = ''
    },
    //60秒钟关闭本弹窗
    startDivi () {
      // const TIME_COUNT = 10;
      // if(!this.timer){
      //   this.count = TIME_COUNT;
      //   this.activity_show = true;
      //   this.timer = setInterval(()=>{
      //     if(this.count > 0 && this.count <= TIME_COUNT){
      //       this.count--;
      //     }else{
      //       this.activity_show = false;
      //       clearInterval(this.timer);
      //       this.timer = null;
      //     }
      //   },1000)
      // }else {
      //   console.log(123)
      // }
      const TIME_COUNT = 60;
      this.count = TIME_COUNT;
      this.activity_show = true;
      this.timer = setInterval(() => {
        if (this.count > 0 && this.count <= TIME_COUNT) {
          this.count--;
        } else {
          this.activity_show = false;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000)
    },
    //90秒钟关闭本弹窗
    startDivi1 () {
      // const TIME_COUNT = 10;
      // if(!this.timer){
      //   this.count = TIME_COUNT;
      //   this.activity_show = true;
      //   this.timer = setInterval(()=>{
      //     if(this.count > 0 && this.count <= TIME_COUNT){
      //       this.count--;
      //     }else{
      //       this.activity_show = false;
      //       clearInterval(this.timer);
      //       this.timer = null;
      //     }
      //   },1000)
      // }else {
      //   console.log(123)
      // }
      const TIME_COUNT = 120;
      this.count = TIME_COUNT;
      this.activity_show = true;
      this.timer = setInterval(() => {
        if (this.count > 0 && this.count <= TIME_COUNT) {
          this.count--;
        } else {
          this.activity_show = false;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000)
    },
    //查询奖品还有多少
    number_of_prizes_select () {
      let that = this;
      let _jsondata_ = {
        lpp_aci_uuid: that.lai_uuid,
      };
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)'
      });
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.postManagerLotteryPoolDetailInfo,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      a1.then((res) => {
        if (res.data.status == 'success') {
          loading.close();
          that.number_tableData = res.data.rows;
          that.number = that.number_tableData[0].unuse;
          console.log("that.number:" + that.number);
          if (that.number === 0) {
            this.lessing_bag1 = true;
            this.lessing_bag2 = false;
          } else if (that.number !== 0) {
            this.lessing_bag1 = false;
            this.lessing_bag2 = true;
          }

        } else {
          console.info("奖品剩余数查询失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(error.message), '奖品剩余数查询出错!', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '奖品剩余数查询出错', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      });
    },
    //打开商品列表
    shop_commodity () {
      this.count_time = '';
      this.commodity_list_select();
      this.commodity_list_select1();
      this.internal_goods_list_select();
      this.commodity_tableData_time();
    },
    tips_qr_code_but (item, i) {
      this.tipsShow = true
      this.objMsg = item
      this.ObjData = {
        item: item,
        i: i,
      }
      this.postQueryGoodsAttachMerInfo();
    },
    // 判断是否是到点交付
    qr_code_but (item) {
      console.log('---------------------------------------------------------');
      console.log(item.mbgi_sale_mode);
      if (item.mbgi_sale_mode == '3') {
        this.tips_qr_code_but(item)
      } else {
        this.qr_code_but_click(item)
      }
    },
    //打开二维码页面
    qr_code_but_click (item, i) {
      if (!item) {
        this.commodity_submitForm11()
        return
      }
      if (item.A !== 0) {
        this.timer_second = 10
        clearInterval(this.timer_new)
        this.timer_new = ''
        clearInterval(this.timer);
        this.count_time = ''
        this.qr_code_show = true;
        this.tipsShow = false
        this.objMsg = item
        this.cq_code1 = true;
        this.cq_code2 = false;
        this.img_commodity.msg = '';
        this.img_commodity.billNo = '';
        this.bank_commodity(2);
        this.postQueryGoodsAttachMerInfo();
      } else if (item.A === 0) {
        this.$message({
          offset: 700,
          type: 'warning',
          showClose: true,
          duration: 3000,
          dangerouslyUseHTMLString: true,
          message: '<span style="color:black;font-size: 50px">很抱歉，没货了！</span>'
        });
      }
    },
    postQueryGoodsAttachMerInfo () {
      let _jsondata_ = {
        mbgi_source: this.objMsg.mbgi_source,
        mbgi_station_id: this.objMsg.mbgi_station_id,
        mbgi_mer_uuid: this.objMsg.mbgi_mer_uuid,
      }
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0)'
      });
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.postQueryGoodsAttachMerInfo,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      a1.then((res) => {
        if (res.data.status == 'success') {
          loading.close();
          this.$set(this.objMsg, 'objMsg_address', res.data.rows[0].address)
          this.$set(this.objMsg, 'objMsg_company', res.data.rows[0].company)
          // console.log('res==', this.objMsg, '---------------------------------------------------------');
        } else {
          console.info("商品查询失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
      });
    },
    commodity_list_close12 () {
      this.qr_code_show = false;
      this.payment_show_Tips = false;
      this.payment_show = false;
      this.payment_show1 = false;
      this.details_page_show = false;
      this.count = '';
      this.tipsShow = false
      this.timer_second = 10
      clearInterval(this.timer_new)
      this.timer_new = ''
      this.clearTime();
      this.commodity_list_select();
      this.commodity_list_select1();
      this.internal_goods_list_select();
      this.commodity_tableData_time();
      clearInterval(this.timer1);
      clearInterval(this.timer5);
      this.timer5 = null;
    },
    //滑动
    arrowClick1 (val) {
      if (val === 'right') {
        this.$refs.nop.next()
      } else {
        this.$refs.nop.prev()
      }
    },
    //商品列表查询
    commodity_list_select () {
      let that = this;
      let _jsondata_ = {
        mbgi_show: '1',
        obj_bank_center_id: that.pri_detail.activityObj.bank_center_id,
        obj_province_id: that.pri_detail.activityObj.province_id,
        obj_city_id: that.pri_detail.activityObj.city_id,
        obj_county_id: that.pri_detail.activityObj.county_id,
        obj_station_id: that.pri_detail.activityObj.station_id,
        mgs_device_uuid: that.pri_detail.activityObj.di_uuid,
        perPageSize: 100,
        currentPage: 1,
      };
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)'
      });
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.Goods_outside_the_equipment_end_select,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      a1.then((res) => {
        if (res.data.status == 'success') {
          loading.close();
          that.commodity_tableData1 = [];
          that.commodity_tableData = [];
          that.commodity_data = [];
          that.commodity_tableData1 = res.data.rows;
          that.commodity_data = this.formatArray(that.commodity_tableData1, 6);
          that.commodity_tableData = this.formatArray(that.commodity_tableData1, 8);

          console.log("commodity_data：", that.commodity_data)
          this.img_select();
          this.img_select1();
          this.business_select();
        } else {
          console.info("商品查询失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        // this.$alert(JSON.stringify(error.message), '商品查询出错!', {
        //   confirmButtonText: '确定',
        //   callback: action => {

        //   }
        // });
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        // this.$alert(JSON.stringify(res.message), '商品查询出错', {
        //   confirmButtonText: '确定',
        //   callback: action => {

        //   }
        // });
      });
    },
    //商品列表查询
    commodity_list_select1 () {
      let that = this;
      let _jsondata_ = {
        mbgi_show: '1',
        obj_bank_center_id: that.pri_detail.activityObj.bank_center_id,
        obj_province_id: that.pri_detail.activityObj.province_id,
        obj_city_id: that.pri_detail.activityObj.city_id,
        obj_county_id: that.pri_detail.activityObj.county_id,
        obj_station_id: that.pri_detail.activityObj.station_id,
        mgs_device_uuid: that.pri_detail.activityObj.di_uuid,
        perPageSize: 100,
        currentPage: 1,
      };
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)'
      });
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.Equipment_home_page_commodity_display_select,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      a1.then((res) => {
        if (res.data.status == 'success') {
          loading.close();
          that.commodity_data1 = this.formatArray(res.data.rows, 6);
          console.log("commodity_data：", that.commodity_data)
          this.img_select();
          this.img_select1();
          this.business_select();
        } else {
          console.info("商品查询失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        // this.$alert(JSON.stringify(error.message), '商品查询出错!', {
        //   confirmButtonText: '确定',
        //   callback: action => {

        //   }
        // });
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        // this.$alert(JSON.stringify(res.message), '商品查询出错', {
        //   confirmButtonText: '确定',
        //   callback: action => {

        //   }
        // });
      });
    },
    //生成优惠价二维码
    commodity_qc_code () {
      this.codeShow = true;
      let baseURI
      let mode = this.objMsg.mbgi_sale_mode == '3' ? '2' : this.objMsg.mbgi_sale_mode //mode 为1时商品在货道内，不为1时商品不在货道内
      let source = this.objMsg.mbgi_source == '3' ? '2' : this.objMsg.mbgi_source //source 为1时是银行商品，不为1时商品非银行商品
      let valueOf = mode + source
      console.log(valueOf, "----------------------");
      switch (valueOf) {
        case '11':
          //货道内扫码(银行自己的礼品)
          baseURI = this.customGlobal.serverUrl.postManagerGenUnionQrCodeForInnerBank;
          break;
        case '21':
          //货道外扫码(银行自己的礼品)
          baseURI = this.customGlobal.serverUrl.postManagerGenUnionQrCodeForOuter;
          break;
        case '12':
          //货道内扫码(非银行礼品)
          baseURI = this.customGlobal.serverUrl.postManagerGenUnionQrCodeForInnerMer;
          break;
        case '22':
          //货道外扫码(非银行礼品)
          baseURI = this.customGlobal.serverUrl.postManagerGenUnionQrCodeForOuterMer;
          break;
        default:
          return;
          break;
      }
      let that = this;
      this.img_commodity.msg = '';
      this.img_commodity.billNo = '';
      let _jsondata_ = {
        bank_company_alias_id: that.transcoding_id.currentCompanyId,
        totalAmount: that.objMsg.mbgi_money_2,
        sale_info: JSON.stringify({
          mbs_sale_mode: this.objMsg.mbgi_sale_mode,
          mbs_use_uuid: '',
          mbs_mer_uuid: that.objMsg.mbgi_mer_uuid,
          mbs_guest_phone: this.phone,
          mbs_goods_uuid: that.objMsg.goods_uuid,
          mbs_goods_type_uuid: that.objMsg.mbgi_uuid,
          mbs_pay_mode: '2',
          mbs_device_id: that.pri_detail.activityObj.di_uuid,
          mdgi_number: that.objMsg.mdgi_number ? that.objMsg.mdgi_number : '无'
        }),
        srcReserve: that.transcoding_id.currentCompanyId,
        mgs_device_id: that.pri_detail.activityObj.di_uuid,
        mgs_mer_uuid: that.objMsg.mbgi_mer_uuid,
        bank_center_id: that.pri_detail.activityObj.bank_center_id,
        province_id: that.pri_detail.activityObj.province_id,
        city_id: that.pri_detail.activityObj.city_id,
        county_id: that.pri_detail.activityObj.county_id,
        station_id: that.pri_detail.activityObj.station_id,
      };
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)'
      });
      var a1 = this.customGlobal.postHttpClient(
        baseURI,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      a1.then((res) => {
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var data_id = year + "-" + month + "-" + day;
        that.commodity_data_id = data_id;
        that.commodity_startDivi();
        that.commodity_startDivi1();
        if (res.data.status == 'success') {
          loading.close();
          that.img_commodity = res.data;
          console.log('二维码：' + JSON.stringify(that.img_commodity.msg));
        } else {
          console.info("生成二维码失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(error.message), '生成二维码出错!', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
        that.qr_code_show = false;
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '生成二维码出错', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
        that.qr_code_show = false;
      });
    },
    //转13位id
    bank_commodity (value) {
      let that = this;
      let _jsondata_ = {
        companyId: that.pri_detail.activityObj.station_id,
      };
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)'
      });
      var s1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.bank_transcoding,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      s1.then((res) => {
        if (res.data.status == 'success') {
          loading.close();
          that.transcoding_id = res.data;
          console.log(that.transcoding_id);
          if (value == 2) {
            that.commodity_qc_code();
          }
        } else {
          console.info("转码失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(error.message), '转码出错!', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '转码出错', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      });
    },
    //特惠价按钮
    phone_but (item, i) {
      console.log(item.A);
      if (item.A !== 0) {
        this.commodity_phone_show = true;
        this.phone = '';
        this.phone_size2 = false;
        this.phone_size1 = false;
        this.objMsg = item
        this.img_commodity.msg = '';
        this.img_commodity.billNo = '';
        this.bank_commodity(1);
        this.postQueryGoodsAttachMerInfo();
      } else if (item.A === 0) {
        this.$message({
          offset: 700,
          type: 'warning',
          showClose: true,
          duration: 3000,
          dangerouslyUseHTMLString: true,
          message: '<span style="color:black;font-size: 50px">很抱歉，没货了！</span>'
        });
      }
    },
    //关闭输入特惠价手机号页面
    commodity_phone_close () {
      this.commodity_phone_show = false;
      this.showKeyBoard = false;
      this.timer_second = 10
      clearInterval(this.timer_new)
      this.timer_new = ''
    },
    //90秒钟关闭本弹窗
    commodity_startDivi () {
      let that = this;
      const TIME_COUNT = 120;
      that.count = TIME_COUNT;
      that.qr_code_show = true;
      clearInterval(that.timer4);
      that.timer4 = setInterval(() => {
        if (that.count > 0 && that.count <= TIME_COUNT) {
          that.count--;
        } else {
          that.qr_code_show = false;
          this.commodity_tableData_time();
          clearInterval(that.timer4);
          that.timer4 = null;
        }
      }, 1000)

    },
    //2秒钟刷新下是否支付
    commodity_startDivi1 () {
      let that = this;
      that.timer1 = setInterval(() => {
        that.commodity_payment();
        // that.count = that.count - 5;
        if (that.count === 0) {
          clearInterval(that.timer1);
          that.qr_code_show = false;
          that.commodity_list_select();
          that.commodity_list_select1();
          that.internal_goods_list_select();
        }
      }, 5000)
    },
    clearTime1 () {
      clearInterval(this.timer);
      this.count1 = ''
    },
    //查询是否支付
    commodity_payment () {
      let that = this;
      let _jsondata_ = {
        bank_company_alias_id: that.transcoding_id.currentCompanyId,
        billNo: that.img_commodity.billNo,
        billDate: that.commodity_data_id,
      };
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)'
      });
      var s1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.postManagerQueryUnionPayOrderForOuter,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      s1.then((res) => {
        if (res.data.status == 'success') {
          loading.close();
          console.log("支付中" + JSON.stringify(res.data));
          if (res.data.billStatus === 'PAID') {
            if (this.objMsg.mbgi_sale_mode == '1') {
              let mbgi_money = JSON.parse(res.data.msg).billPayment.totalAmount
              es6.callAndroidDeviceReqShipMethod(that.objMsg.mdgi_number, 'PAYMETHED_WECHAT', mbgi_money, res.data.billNo);
            }
            this.billNo = res.data.billNo.substring(res.data.billNo.length - 6)
            if (!this.objMsg.mdgi_number) {
              this.payment_show_Tips = true
            }
            clearInterval(that.timer1);
            that.timer1 = null;
            this.qr_code_show = false
            clearInterval(that.timer4);
            that.timer4 = null;
            that.commodity_payment_time();
          }
        } else {
          clearInterval(that.timer1)
          that.timer1 = null
          this.qr_code_show = false
          clearInterval(that.timer4)
          that.timer4 = null
          that.commodity_payment_time()
          console.info("转码失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        clearInterval(that.timer1)
        that.timer1 = null
        this.qr_code_show = false
        clearInterval(that.timer4)
        that.timer4 = null
        that.commodity_payment_time()
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(error.message), '转码出错!', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      }).catch((res) => {
        clearInterval(that.timer1)
        that.timer1 = null
        this.qr_code_show = false
        clearInterval(that.timer4)
        that.timer4 = null
        that.commodity_payment_time()
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '转码出错', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      });
    },
    commodity_submitForm11 () {
      this.timer_second = 10
      clearInterval(this.timer_new)
      this.timer_new = ''
      this.commodity_qc_code1();
      this.cq_code1 = false;
      this.tipsShow = false;
      this.cq_code2 = true;
    },
    //特惠价表单验证
    commodity_submitForm () {
      let that = this;
      this.showKeyBoard = false;
      let _jsondata_ = {
        mau_guest_phone: that.phone,
        obj_bank_center_id: that.pri_detail.activityObj.bank_center_id,
        obj_province_id: that.pri_detail.activityObj.province_id,
        obj_city_id: that.pri_detail.activityObj.city_id,
        obj_county_id: that.pri_detail.activityObj.county_id,
        obj_station_id: that.pri_detail.activityObj.station_id,
      };
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)'
      });
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.postManager_Purchase_logic_select,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      a1.then((res) => {
        if (res.data.status == 'success') {
          loading.close();
          var total = res.data;
          if (total.total == '0') {
            that.phone_size1 = true;
            that.phone_size2 = false;
          } else {
            if (total.mau_get_status_new === '2') {
              that.mau_uuid_new = total.mau_uuid_new;
              this.commodity_phone_close()
              that.tipsShow = true;
              this.ObjData = {
                item: '',
                i: '',
              }
            } else if (total.mau_get_status_new === '3') {
              that.mbs_writetime_new = total.mbs_writetime_new;
              that.phone_size1 = false;
              that.phone_size2 = true;
            }
          }
        } else {
          console.info("手机号查询失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(error.message), '手机号查询出错!', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '手机号查询出错', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      });
    },
    //生成特惠价二维码
    commodity_qc_code1 () {
      this.codeShow = false;
      let baseURI
      let mode = this.objMsg.mbgi_sale_mode == '3' ? '2' : this.objMsg.mbgi_sale_mode //mode 为1时商品在货道内，不为1时商品不在货道内
      let source = this.objMsg.mbgi_source == '3' ? '2' : this.objMsg.mbgi_source //source 为1时是银行商品，不为1时商品非银行商品
      let valueOf = mode + source

      switch (valueOf) {
        case '11':
          //货道内扫码(银行自己的礼品)
          baseURI = this.customGlobal.serverUrl.postManagerGenUnionQrCodeForInnerBank;
          break;
        case '21':
          //货道外扫码(银行自己的礼品)
          baseURI = this.customGlobal.serverUrl.postManagerGenUnionQrCodeForOuter;
          break;
        case '12':
          //货道内扫码(非银行礼品)
          baseURI = this.customGlobal.serverUrl.postManagerGenUnionQrCodeForInnerMer;
          break;
        case '22':
          //货道外扫码(非银行礼品)
          baseURI = this.customGlobal.serverUrl.postManagerGenUnionQrCodeForOuterMer;
          break;
        default:
          return;
          break;
      }
      let that = this;
      let _jsondata_ = {
        bank_company_alias_id: that.transcoding_id.currentCompanyId,
        totalAmount: that.objMsg.mbgi_money_3,
        sale_info: JSON.stringify({
          mbs_sale_mode: this.objMsg.mbgi_sale_mode,
          mbs_use_uuid: that.mau_uuid_new,
          mbs_mer_uuid: that.objMsg.mbgi_mer_uuid,
          mbs_guest_phone: this.phone,
          mbs_goods_uuid: that.objMsg.goods_uuid,
          mbs_goods_type_uuid: that.objMsg.mbgi_uuid,
          mbs_pay_mode: '3',
          mbs_device_id: that.pri_detail.activityObj.di_uuid,
          mdgi_number: that.objMsg.mdgi_number ? that.objMsg.mdgi_number : '无'
        }),
        srcReserve: that.transcoding_id.currentCompanyId,
        mgs_device_id: that.pri_detail.activityObj.di_uuid,
        mgs_mer_uuid: that.objMsg.mbgi_mer_uuid,
        bank_center_id: that.pri_detail.activityObj.bank_center_id,
        province_id: that.pri_detail.activityObj.province_id,
        city_id: that.pri_detail.activityObj.city_id,
        county_id: that.pri_detail.activityObj.county_id,
        station_id: that.pri_detail.activityObj.station_id,
      };
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)'
      });
      var a1 = this.customGlobal.postHttpClient(
        baseURI,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      a1.then((res) => {
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var data_id = year + "-" + month + "-" + day;
        that.commodity_data_id = data_id;
        that.commodity_startDivi();
        that.commodity_startDivi1();
        if (res.data.status == 'success') {
          loading.close();
          that.img_commodity = res.data;
          console.log('二维码：' + JSON.stringify(that.img_commodity.msg));
        } else {
          console.info("生成二维码失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(error.message), '生成二维码出错!', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '生成二维码出错', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      });
    },
    //90秒钟关闭本弹窗
    commodity_tableData_time () {
      let that = this;
      that.count_time = '';
      const TIME_COUNT = 120;
      that.count_time = TIME_COUNT;
      clearInterval(this.timer3);
      this.timer3 = null;
      that.timer3 = setInterval(() => {
        if (that.count_time > 0 && that.count_time <= TIME_COUNT) {
          that.count_time--;
        } else {
          clearInterval(that.timer3);
          that.timer3 = null;
        }
      }, 1000)

    },
    //30秒钟关闭支付弹窗
    commodity_payment_time () {
      let that = this;
      that.payment_time = '';
      const TIME_COUNT = 30;
      that.payment_time = TIME_COUNT;
      clearInterval(that.timer5);
      that.timer5 = null;
      that.timer5 = setInterval(() => {
        if (that.payment_time > 0 && that.payment_time <= TIME_COUNT) {
          that.payment_time--;
        } else {
          that.payment_show = false;
          that.payment_show1 = false;
          this.qr_code_show = false;
          this.commodity_list_select();
          this.commodity_list_select1();
          this.internal_goods_list_select();
          clearInterval(that.timer5);
          that.timer5 = null;
        }
      }, 1000)

    },
    next1 (txt, e) {
      e.preventDefault();
      console.info("" + txt);
      this.$refs.cardShow.next();
    },
    prev1 (txt, e) {
      e.preventDefault();
      console.info("" + txt);
      this.$refs.cardShow.next();
    },

    //查询图片
    img_select () {
      let that = this;
      let _jsondata_ = {
        perPageSize: 100,
        currentPage: 1,
        obj_bank_center_id: that.pri_detail.activityObj.bank_center_id,
        company_id: that.customGlobal.userInfoExt.company_id,
        obj_province_id: that.pri_detail.activityObj.province_id,
        obj_city_id: that.pri_detail.activityObj.city_id,
        obj_county_id: that.pri_detail.activityObj.county_id,
        obj_station_id: that.pri_detail.activityObj.station_id,
        bdbi_type: '1',
        bdbi_status: '1',
        bdbi_device_id: that.pri_detail.activityObj.di_uuid,
      };
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)'
      });
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.postManager_Advertisement_select,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      a1.then((res) => {
        if (res.data.status === 'success') {
          loading.close();
          that.img_data = [];
          that.img_data = res.data.rows;
        } else {
          console.info("图片查询失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(error.message), '图片查询失败!', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '图片查询失败', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      });
    },
    //查询首页二维码
    img_select1 () {
      let that = this;
      let _jsondata_ = {
        perPageSize: 100,
        currentPage: 1,
        obj_bank_center_id: that.pri_detail.activityObj.bank_center_id,
        obj_province_id: that.pri_detail.activityObj.province_id,
        company_id: that.customGlobal.userInfoExt.company_id,
        obj_city_id: that.pri_detail.activityObj.city_id,
        obj_county_id: that.pri_detail.activityObj.county_id,
        obj_station_id: that.pri_detail.activityObj.station_id,
        bdbi_type: '3',
        bdbi_status: '1',
        bdbi_device_id: '',
        bdbi_qr_type: '2'
      };
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)'
      });
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.postManager_Advertisement_select,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      a1.then((res) => {
        if (res.data.status === 'success') {
          loading.close();
          that.code_img_data = [];
          that.code_img_data = res.data.rows;
          if (that.code_img_data.length > 0) {
            that.bdbi_path = that.code_img_data[0].bdbi_path;
          }
        } else {
          console.info("图片查询失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(error.message), '图片查询失败!', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '图片查询失败', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      });
    },
    //查询业务馆活动
    business_select () {
      let that = this;
      let _jsondata_ = {
        perPageSize: 1000,
        currentPage: 1,
        bai_bank_center_id: that.pri_detail.activityObj.bank_center_id,
        bai_province_id: that.pri_detail.activityObj.province_id,
        bai_city_id: that.pri_detail.activityObj.city_id,
        bai_county_id: that.pri_detail.activityObj.county_id,
        bai_station_id: that.pri_detail.activityObj.station_id,
      };
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)'
      });
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.postManagerBankGuestGetActivityList,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      a1.then((res) => {
        if (res.data.status === 'success') {
          loading.close();
          that.business_data = [];
          that.business_data1 = [];
          that.business_data1 = res.data.rows;
          that.business_data = this.formatArray(that.business_data1, 3);
          console.log('res==', that.business_data, '---------------------------------------------------------');
        } else {
          console.info("活动查询失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(error.message), '活动查询失败!', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '活动查询失败', {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      });
    },
    prev2 (txt, e) {
      e.preventDefault();
      console.info("" + txt);
      this.$refs.nop1.prev();
    },
    next2 (txt, e) {
      e.preventDefault();
      console.info("" + txt);
      this.$refs.nop1.next();
    },
    arrowClick2 (val) {
      if (val === 'right') {
        this.$refs.nop1.next()
      } else {
        this.$refs.nop1.prev()
      }
    },
    //数字人民币
    number_renminbi () {
      this.$alert('暂未开通', '操作提示', {
        dangerouslyUseHTMLString: true
      });
    },
    //商品列表查询
    internal_goods_list_select () {
      let that = this;
      let _jsondata_ = {
        mbgi_show: '1',
        obj_bank_center_id: that.pri_detail.activityObj.bank_center_id,
        obj_province_id: that.pri_detail.activityObj.province_id,
        obj_city_id: that.pri_detail.activityObj.city_id,
        obj_county_id: that.pri_detail.activityObj.county_id,
        obj_station_id: that.pri_detail.activityObj.station_id,
        mdgi_device_uuid: that.pri_detail.activityObj.di_uuid,
        perPageSize: 100,
        currentPage: 1,
      };
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0)'
      });
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.postManagerPurchase_page_goods_in_the_device_select,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        { "Content-Type": "application/x-www-form-urlencoded" },
        this.qs.stringify({ jsondata: JSON.stringify(_jsondata_) })
      );
      a1.then((res) => {
        if (res.data.status == 'success') {
          loading.close();
          that.internal_goods_tableData1 = [];
          that.internal_goods_tableData = [];
          that.internal_goods_data = [];
          that.internal_goods_tableData1 = res.data.rows;
          that.internal_goods_data = this.formatArray(that.internal_goods_tableData1, 4);
          that.internal_goods_tableData = this.formatArray(that.internal_goods_tableData1, 8);
          console.log('that.internal_goods_tableData==', that.internal_goods_tableData, '---------------------------------------------------------');
        } else {
          console.info("商品查询失败");
          loading.close();
          if (res.data.msg === '请登录认证') {
            this.$router.push({ path: '/login' });
          }
        }
      }, error => {
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        // this.$alert(JSON.stringify(error.message), '商品查询出错!', {
        //   confirmButtonText: '确定',
        //   callback: action => {

        //   }
        // });
      }).catch((res) => {
        console.log("异步调用失败返回:" + JSON.stringify(res));
        loading.close();
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        // this.$alert(JSON.stringify(res.message), '商品查询出错', {
        //   confirmButtonText: '确定',
        //   callback: action => {

        //   }
        // });
      });
    },
  }
}
</script>
<style scoped>
.simple-keyboard {
  max-width: 850px;
  padding: 15px;
  margin: 0 auto;
  margin-top: 10px;
  box-shadow: 0 4px 0 #b2b2b2, 0 7px 16px rgba(0, 0, 0, 0.6);
}

.hg-theme-default .hg-button.hg-standardBtn {
  height: 130px;
  margin: 8px 10px;
  font-size: 30px;
  background-color: #fff;
  border-radius: 8px;
  cursor: pointer;
  -webkit-box-shadow: 0 4px 0 #b2b2b2, 0 5px 10px rgba(0, 0, 0, 0.7);
  box-shadow: 0 3px 0 #b2b2b2, 0 4px 6px rgba(0, 0, 0, 0.7);
}

.hg-theme-default .hg-button.hg-standardBtn:active {
  box-shadow: 0 4px 0 #717070, 0 5px 3px rgba(0, 0, 0, 0.9);
  background-color: #efefef;
}

.simple-keyboard.hg-layout-default .hg-button.bksp {
  height: 130px;
  margin: 8px 0 8px 12px;
  font-size: 30px;
  background-color: #fff;
  border-radius: 8px;
  cursor: pointer;
  -webkit-box-shadow: 0 4px 0 #b2b2b2, 0 5px 10px rgba(0, 0, 0, 0.7);
  box-shadow: 0 3px 0 #b2b2b2, 0 4px 6px rgba(0, 0, 0, 0.7);
  background: #fb9163;
  color: white;
}

.simple-keyboard.hg-layout-default .hg-button.bksp:active {
  box-shadow: 0 4px 0 #717070, 0 5px 3px rgba(0, 0, 0, 0.9);
  background-color: #efefef;
  color: #000000;
}

.simple-keyboard.hg-layout-default .hg-button.enter {
  height: 130px;
  margin: 8px 10px 8px 8px;
  font-size: 30px;
  background-color: #fff;
  border-radius: 8px;
  cursor: pointer;
  -webkit-box-shadow: 0 4px 0 #b2b2b2, 0 5px 10px rgba(0, 0, 0, 0.7);
  box-shadow: 0 3px 0 #b2b2b2, 0 4px 6px rgba(0, 0, 0, 0.7);
  background: #fb9163;
  color: white;
}

.simple-keyboard.hg-layout-default .hg-button.enter:active {
  box-shadow: 0 4px 0 #717070, 0 5px 3px rgba(0, 0, 0, 0.9);
  background-color: #efefef;
  color: #000000;
}
</style>
<style scoped>
.click_back:active {
  color: red;
}

.click_border:active {
  border: 2px solid red;
  border-radius: 5px;
}

.click_border1 {
  border: 2px solid #c0c4cc;
}

.click_border1:active {
  border: 2px solid red;
  border-radius: 5px;
}

.v-touch {
  touch-action: pan-y !important;
}

.new-item1 /deep/ .el-carousel__indicator--horizontal > .el-carousel__button {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: #d2d7dc;
  margin: 5px 10px 0 10px;
}

.new-item2
  /deep/
  .el-carousel__indicator--horizontal.is-active
  > .el-carousel__button {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: #fec58e;
  margin: 5px 10px 0 10px;
}

.zzc_box {
  width: 1080px;
  height: 1920px;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  display: block;
}

.account-plat-formitem /deep/ .el-form-item {
  margin-bottom: 3px !important;
}

.input1 /deep/ .el-input__inner {
  height: 71px;
  font-size: 30px;
}

.input2 /deep/ .el-form-item__error {
  margin: 240px 0 0 130px;
  font-size: 20px;
}

.cake {
  animation: move 2s 0s 50 forwards;
  -webkit-animation: move 2s 0s 50 forwards;
  transform-origin: bottom;
  -webkit-transform-origin: bottom;
}

@keyframes move {
  0%,
  65% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  70% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }

  75% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }

  80% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }

  85% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }

  90% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }

  95% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }

  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}

@-webkit-keyframes move {
  0%,
  65% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  70% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }

  75% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }

  80% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }

  85% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }

  90% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }

  95% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }

  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}

.new-item3 /deep/ .el-carousel__button {
  margin-left: -100px;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: #d2d7dc;
  margin-top: 10px;
}

.new-item4 /deep/ .is-active .el-carousel__button {
  background: red;
  margin-left: -100px;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  margin-top: 10px;
}

.banner /deep/ .el-carousel__indicator .el-carousel__indicator--horizontal {
  position: absolute;
  bottom: 0;
  left: 0;
}

.box {
  width: 1080px;
  height: 1772px;
  background: #f5f6f7;
  position: relative;
}

.header {
  width: 1080px;
  height: 560px;
  background-image: linear-gradient(#fdad54 10%, #f5f6f7);
}

.content_top {
  width: 1000px;
  display: flex;
  justify-content: space-between;
  margin: 20px 0 10px 40px;
  position: relative;
}

.hand {
  width: 30px;
  height: 30px;
  margin-right: 5px;
  margin-bottom: 6px;
}

.book {
  width: 30px;
  height: 40px;
  margin-right: 25px;
}

.content_nav_left {
  width: 600px;
  height: 310px;
  position: relative;
}

.box >>> .el-card__body {
  padding: 0 !important;
  margin: 0 !important;
}

.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.image_frame {
  background-size: 99%;
  width: 240px;
  height: 240px;
  background-repeat: no-repeat;
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image_frame1 {
  background-size: 99%;
  width: 750px;
  height: 400px;
  background-repeat: no-repeat;
  margin: 50px auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn_big {
  width: 400px;
  height: 80px;
  line-height: 80px;
  margin: 140px auto;
  font-size: 36px;
  font-weight: 600;
  letter-spacing: 4px;
  border-radius: 15px;
  background-color: rgb(240, 163, 83);
  box-shadow: rgb(125, 125, 125) -2px 2px 2px 2px;
}

.big_btn {
  font-size: 42px;
  letter-spacing: 4px;
  margin: 75px auto 0;
  width: 500px;
  height: 100px;
  line-height: 100px;
  font-weight: 600;
  border-radius: 15px;
  background-color: rgb(240, 163, 83);
  box-shadow: rgb(125, 125, 125) -2px 2px 2px 2px;
}

.box_center {
  width: 1000px;
  height: 650px;
  margin: 80px 0 35px 40px;
  display: flex;
  justify-content: space-between;
  padding-top: 5px;
}

.center_nav {
  width: 100%;
  height: 80px;
  border-radius: 10px;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  padding-top: 8px;
  background-image: url(../../../../assets/images/center_nav.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.content {
  width: 1000px;
  height: 660px;
  border-radius: 20px;
  margin: 20px 0 10px 40px;
  background-color: rgb(208, 233, 247);
  position: relative;
}

.content_nav {
  padding: 10px 30px 0;
  font-size: 30px;
  color: #333333;
  display: flex;
  align-items: center;
  font-weight: 700;
  width: 100%;
  height: 60px;
}

.content_nav_btn {
  width: 376px;
  height: 60px;
  margin-left: 102px;
  display: flex;
  justify-content: space-between;
}

.btn1 {
  width: 180px;
  height: 100%;
  text-align: center;
  line-height: 60px;
  font-size: 24px;
  letter-spacing: 2px;
  color: rgb(252, 241, 214);
  background-image: linear-gradient(rgb(244, 77, 65), rgb(255, 131, 94));
  border-radius: 10px 10px 0 0;
}

.btn_border1 {
  background-color: rgb(254, 110, 72);
  position: absolute;
  width: 180px;
  height: 3px;
  top: 100px;
  right: 230px;
}

.btn_border2 {
  background-color: rgb(254, 110, 72);
  position: absolute;
  width: 180px;
  height: 3px;
  top: 100px;
  right: 33px;
}

.modular {
  width: 100%;
  height: 550px;
  border-radius: 10px;
  margin-top: 10px;
  background-image: url(../../../../assets/images/md.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  font-size: 16px;
  padding-top: 35px;
  box-sizing: border-box;
  font-weight: 700;
}

.right_btn {
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
}

.box /deep/ .el-carousel__item {
  width: 100%;
  padding: 10px 10px;
  box-sizing: border-box;
}

.content /deep/ .el-carousel__indicators {
  display: none;
}

.bottom {
  width: 1000px;
  height: 168px;
  margin: 29px auto;
  display: flex;
  justify-content: space-between;
  background-color: rgb(230, 239, 244);
  align-items: center;
  border-radius: 10px;
}

.bottom_left {
  margin-left: 30px;
  width: 400px;
  height: 130px;
  display: flex;
  border: 1px solid rgb(177, 230, 212);
  border-radius: 10px;
}

.bottom_left_size {
  width: 47px;
  background-color: rgb(209, 233, 246);
  padding: 23px 10px;
  box-sizing: border-box;
  font-weight: 700;
  line-height: 20px;
}

.bottom_left_content {
  width: 100%;
  font-weight: 700;
  padding: 20px 30px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.bottom_right {
  width: 480px;
  padding-right: 10px;
  padding-top: 20px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/views/bankPlatform/deviceIndex/defaultIndex_1.vue